import { queryOptions } from '@tanstack/react-query'
import type { SystemKeyVm } from '../model/systemkey.model'
import systemkeyService from './systemkey.service'

export const QUERY_COMMON_KEY = 'common'

export const systemKeyQueries = {
  /** Toàn bộ systemkey. GET /api/system-keys trả đủ (BE cache 24h); /combobox bắt buộc codeKey nên gọi rỗng là 400. */
  list: () =>
    queryOptions({
      queryKey: [QUERY_COMMON_KEY],
      queryFn: async (): Promise<SystemKeyVm[]> => {
        const res = await systemkeyService.getList()
        return res.object
      },
      staleTime: 10 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
      refetchOnWindowFocus: false,
    }),
}
